<!--
 * @Description: 
 * @Date: 2020-09-25 16:08:09
-->
<template>
  <div class="list">
    <div class="list-top">
      <p class="list-top-title">{{pdata.moduleName}}</p>
      <p class="list-top-look" @click="jump" v-if="pdata.list.length">查看全部</p>
    </div>
    <template v-if="pdata.list.length">
      <div :class="['list-content',[4,5].includes(pdata.moduleType)  ? 'list-content--survey' : '']">
        <listItem v-for="(item,index) in pdata.list" :key="index" :item="item" :type="pdata.moduleType">
          <template #footer>
            <div class="line" v-if="index != pdata.list.length - 1 && pdata.moduleType < 3"></div>
          </template>
        </listItem>
      </div>
    </template>
    <div v-else class="missBox">
      <img src="../../../static/img/missing.png" />
      <p>抱歉，暂无内容呦~</p>
    </div>
  </div>
</template>

<script>
import listItem from '@/components/list/listItem';

export default {
  props: {
    pdata: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  components: { listItem },
  watch: {},
  computed: {},
  methods: {
    jump() {
      this.$router.push({
        name: 'list',
        query: {
          listType: this.pdata.moduleType
        }
      });
    }
  },
  created() {},
  beforeDestroy() {}
};
</script>

<style scoped lang='less'>
.list {
  padding: 0.43rem 0.43rem 0;
  background: #fff;
  margin-bottom: 0.32rem;
  &-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    &-title {
      font-size: 0.53rem;
      font-weight: bold;
    }
    &-look {
      padding: 0.11rem 0.21rem;
      font-size: 0.32rem;
      color: #3667ec;
      border-radius: 0.27rem;
      border: 0.03rem solid;
      line-height: 1;
    }
  }
  &-content {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    &--survey {
      padding-bottom: 0.32rem;
      /deep/ .common {
        padding-bottom: 0;
      }
    }
  }
  .line {
    height: 0.01rem;
    background: #f4f5fa;
  }
  .missBox {
    text-align: center;
    padding: 0.64rem 0;
    img {
      width: 2rem;
      height: 2rem;
      margin-bottom: 0.68rem;
    }
    p {
      font-size: 0.43rem;
      font-weight: 400;
      color: rgba(149, 149, 153, 1);
      line-height: 0.43rem;
    }
  }
}
</style>
